<template>
  <div class="task-manager">

    <!-- Task Editor -->
    <div class="editor">
      <h2>{{ editingIndex === null ? 'New Task' : 'Edit Task' }}</h2>
      <form @submit.prevent="saveTask">
        <div>
          <label for="name">Name:</label>
          <input v-model="taskForm.name" id="name" type="text" required />
        </div>
        <div>
          <label for="description">Description:</label>
          <textarea v-model="taskForm.description" id="description" rows="4"></textarea>
        </div>
        <button type="submit">{{ editingIndex === null ? 'Add Task' : 'Update Task' }}</button>
        <button type="button" v-if="editingIndex !== null" @click="cancelEdit">Cancel</button>
      </form>
    </div>

    <!-- Task List -->
    <div class="task-list">
      <h2>All Tasks</h2>
      <ul>
        <li 
          v-for="(task, index) in tasks" 
          :key="index"
          @click="editTask(index)"
          class="task-item"
        >
          <strong>{{ task.name }}</strong>
          <p>{{ task.description }}</p>
        </li>
      </ul>
    </div>

  </div>
</template>

<script setup>
import { reactive, ref } from 'vue'

const tasks = ref([])
const editingIndex = ref(null)

const taskForm = reactive({
  name: '',
  description: ''
})

function saveTask() {
  if (editingIndex.value === null) {
    tasks.value.push({ ...taskForm })
  } else {
    tasks.value[editingIndex.value] = { ...taskForm }
  }
  resetForm()
}

function editTask(index) {
  const task = tasks.value[index]
  taskForm.name = task.name
  taskForm.description = task.description
  editingIndex.value = index
}

function cancelEdit() {
  resetForm()
}

function resetForm() {
  taskForm.name = ''
  taskForm.description = ''
  editingIndex.value = null
}
</script>

<style scoped>
.task-manager {
  display: flex;
  flex-direction: column;
  max-width: 800px;
  margin: auto;
  gap: 2rem;
  padding: 2rem;
}

.editor {
  padding: 1rem;
  border: 1px solid #ccc;
  border-radius: 10px;
}

.editor input,
.editor textarea {
  display: block;
  width: 100%;
  margin-top: 0.25rem;
  margin-bottom: 1rem;
  padding: 0.5rem;
}

.task-list ul {
  list-style: none;
  padding: 0;
}

.task-item {
  border: 1px solid #eee;
  padding: 1rem;
  margin-bottom: 0.5rem;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.2s;
}

.task-item:hover {
  background: #f9f9f9;
}
</style>
